export const FILTER_NAME = 'currency_rate'
